import { styled } from '@mui/system';
import Select from '@mui/material/Select';
import {
  getItemDescriptionsAndPricesTypography,
  getSectionNavLighterColor,
  getSectionNavLightColor
} from 'styles/helpers/getThemeStyles';

const StyledSelectColorAndBorderSectionNavLinkMain = styled(Select)(
  ({ theme }) => {
    return {
      border: `1px solid ${getSectionNavLighterColor(theme)}`,
      color: theme.palette.sectionNav.link.main,
      ...getItemDescriptionsAndPricesTypography(theme),
      '& .MuiSvgIcon-root': {
        fill: getSectionNavLightColor(theme)
      }
    };
  }
);

export default StyledSelectColorAndBorderSectionNavLinkMain;
